import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-popup-dialog',
    templateUrl: './popup-dialog.component.html',
    styleUrls: ['./popup-dialog.component.scss'],
    standalone: false
})
export class PopupDialogComponent implements OnInit {
  public static result = false;

  title: string = '';
  dialogData: any = {};

  constructor(
    public dialogRef: MatDialogRef<PopupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.dialogData = JSON.parse(JSON.stringify(this.data || {}));
    this.title = this.dialogData?.title || '';
  }

  ngOnInit(): void {
    PopupDialogComponent.result = false;
  }

  get isServiceableAlert(): boolean {
    const t = (this.title || '').toLowerCase();
    return t.includes('serviceable') || t.includes('address') || t.includes('location');
  }

  get isAuthAlert(): boolean {
    const t = (this.title || '').toLowerCase();
    return t.includes('sign-in') || t.includes('sign up') || t.includes('login');
  }

  get isConfirmAlert(): boolean {
    const t = (this.title || '').toLowerCase();
    return t.includes('sure') || t.includes('delete') || t.includes('remove');
  }

  get iconName(): string {
    if (this.dialogData?.icon) {
      return this.dialogData.icon;
    }
    if (this.isServiceableAlert) {
      return 'location_off';
    }
    if (this.isAuthAlert) {
      return 'account_circle';
    }
    if (this.isConfirmAlert) {
      return 'help_outline';
    }
    return 'info_outline';
  }

  get iconTheme(): 'warning' | 'primary' | 'danger' | 'info' {
    if (this.dialogData?.theme) {
      return this.dialogData.theme;
    }
    if (this.isServiceableAlert) {
      return 'warning';
    }
    if (this.isConfirmAlert && (this.title.toLowerCase().includes('delete') || this.title.toLowerCase().includes('remove'))) {
      return 'danger';
    }
    if (this.isAuthAlert) {
      return 'primary';
    }
    return 'info';
  }

  get heading(): string {
    if (this.dialogData?.heading) {
      return this.dialogData.heading;
    }
    if (this.isServiceableAlert) {
      return 'Location Not Serviceable';
    }
    if (this.isAuthAlert) {
      return 'Sign In Required';
    }
    if (this.isConfirmAlert) {
      return 'Are you sure?';
    }
    return this.title || 'Notice';
  }

  get message(): string {
    if (this.dialogData?.message) {
      return this.dialogData.message;
    }
    if (this.isServiceableAlert) {
      return 'Your delivery address is currently not serviceable. Would you like to update your address?';
    }
    if (this.isAuthAlert) {
      return 'Please sign in or create an account to continue.';
    }
    if (this.isConfirmAlert) {
      return this.dialogData?.description || 'Are you sure you want to proceed with this action?';
    }
    if (this.heading !== this.title) {
      return this.title;
    }
    return this.dialogData?.description || '';
  }

  get confirmLabel(): string {
    if (this.dialogData?.confirmText) {
      return this.dialogData.confirmText;
    }
    if (this.isServiceableAlert) {
      return 'Update Address';
    }
    if (this.isAuthAlert) {
      return 'Sign In';
    }
    return 'Yes';
  }

  get cancelLabel(): string {
    if (this.dialogData?.cancelText) {
      return this.dialogData.cancelText;
    }
    if (this.isServiceableAlert || this.isAuthAlert) {
      return 'Not Now';
    }
    return 'No';
  }

  onYes(): void {
    PopupDialogComponent.result = true;
    this.dialogRef.close(true);
  }

  onNo(): void {
    PopupDialogComponent.result = false;
    this.dialogRef.close(false);
  }

  onClose(): void {
    PopupDialogComponent.result = false;
    this.dialogRef.close(false);
  }
}
